import styled, { css } from 'styled-components'

import { theme } from '@src/containers/WordStat/common'

type StyledResizeHandleProps = {
  isResizing: boolean
}

export const ResizeHandle = styled.div<StyledResizeHandleProps>`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  background: rgba(0, 0, 0, 0.5);
  cursor: col-resize;
  user-select: none;
  touch-action: none;

  @media (hover: hover) {
    opacity: 0;

    &:hover {
      opacity: 1;
    }
  }

  ${({ isResizing }) =>
    isResizing &&
    css`
      background: blue;
      opacity: 1;
    `}
`

export const Container = styled.div`
  --border-radius: 5px;
  position: relative;
  border: 1px solid ${theme.palette.black(80)};
  border-radius: var(--border-radius);
  overflow: hidden;
`

export const ScrollingContainer = styled.div`
  // @TODO: when Navigation is enabled again
  // --height: 480px;
  --height: calc(480px + 60px);

  overflow-y: auto;

  position: relative;
  background-color: ${theme.palette.white};
  height: var(--height);
`

const tableHeaderCss = css`
  thead tr {
    height: var(--header-height);
  }

  th {
    background-color: ${theme.palette.black(98)};
    z-index: 2;
    position: sticky;
    top: 0;

    font: inherit;
    text-align: inherit;

    padding: var(--cell-padding);
    border-bottom: 1px solid ${theme.palette.black(80)};

    &:not(:last-child)::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 0;
      height: calc(var(--height) - 2px);
      border-right: 1px solid ${theme.palette.black(80)};
    }

    &:first-of-type {
      border-top-left-radius: var(--border-radius);
    }

    &:last-of-type {
      border-top-right-radius: var(--border-radius);
    }
  }

  @media (hover: hover) {
    thead *:hover > ${ResizeHandle} {
      opacity: 1;
    }
  }
`

// @NOTE row-height такой потому что сверху паддинг 5px ???
export const Table = styled.table`
  --header-height: 40px;
  --table-body-vertical-padding: 10px;
  --line-height: 30px;
  --cell-padding: 0 10px;
  --line-height: 20px;

  // --row-height: calc(var(--line-height) + var(--table-body-vertical-padding));
  --row-height: var(--line-height) + 10px;

  width: 100%;
  height: 100%;
  font-size: 14px;
  line-height: var(--row-height);

  ${tableHeaderCss};

  tr {
    position: relative;
    touch-action: none;
  }

  tbody {
    td {
      padding: var(--cell-padding);
      vertical-align: top;
    }
  }
`

export const TextCellContent = styled.span`
  display: inline-block;
  padding: 0 5px;
  line-height: 30px;
`

export const FlexCellContent = styled.div`
  display: flex;
  padding: 5px;
`

export const SelectCellContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 30px;

  & label {
    width: 20px;
    z-index: 1;
  }
`
